module.exports = __webpack_public_path__ + "img/model-img4.c615198f.png";